module.exports = __webpack_public_path__ + "img/oldmail-01@2x.87af2cfa.png";